import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const [status, setStatus] = useState("checking");
  const [isTrial, setIsTrial] = useState(false);
  const sessionId = params.get("session_id");

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setStatus("paid");
          checkAuth();
          try { const { data: s } = await api.get("/subscription"); setIsTrial(s.subscription_status === "trialing" || s.plan === "trialing"); } catch (e) {}
          return;
        }
        if (data.status === "failed" || data.payment_status === "failed") { setStatus("error"); return; }
      } catch (e) {}
      if (tries++ < 8) setTimeout(poll, 2000);
      else setStatus("pending");
    };
    poll();
  }, [sessionId, checkAuth]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-5">
      <div className="bg-white border border-border rounded-2xl p-10 max-w-md text-center" data-testid="payment-success-card">
        {status === "checking" && (<><div className="w-10 h-10 border-2 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4" /><p className="text-slate-600">Confirmation du paiement…</p></>)}
        {status === "paid" && (<><CheckCircle2 className="w-14 h-14 text-emerald-500 mx-auto mb-4" /><h1 className="font-display text-2xl font-extrabold text-slate-900">{isTrial ? "Essai activé !" : "Abonnement activé !"}</h1><p className="text-slate-500 mt-2">{isTrial ? "Votre essai gratuit a démarré : vous avez accès à tout. Aucun montant n'est débité pendant l'essai." : "Merci ! Votre abonnement est actif, vous avez désormais accès à votre espace."}</p><Button className="mt-6 rounded-full" onClick={() => navigate("/dashboard")} data-testid="payment-success-dashboard-btn">Aller à mon espace</Button></>)}
        {status === "pending" && (<><div className="w-10 h-10 border-2 border-amber-400 border-t-transparent rounded-full animate-spin mx-auto mb-4" /><p className="text-slate-600">Paiement en cours de traitement. Tu peux revenir à ton espace.</p><Button className="mt-6 rounded-full" onClick={() => navigate("/dashboard")}>Mon espace</Button></>)}
        {status === "error" && (<><XCircle className="w-14 h-14 text-red-500 mx-auto mb-4" /><h1 className="font-display text-2xl font-extrabold text-slate-900">Un souci est survenu</h1><Button className="mt-6 rounded-full" onClick={() => navigate("/abonnement")}>Réessayer</Button></>)}
      </div>
    </div>
  );
}

export function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-5">
      <div className="bg-white border border-border rounded-2xl p-10 max-w-md text-center">
        <XCircle className="w-14 h-14 text-slate-300 mx-auto mb-4" />
        <h1 className="font-display text-2xl font-extrabold text-slate-900">Paiement annulé</h1>
        <p className="text-slate-500 mt-2">Aucun montant n'a été débité.</p>
        <Button className="mt-6 rounded-full" onClick={() => navigate("/abonnement")} data-testid="payment-cancel-retry-btn">Revenir aux formules</Button>
      </div>
    </div>
  );
}
